import { render, staticRenderFns } from "./network.vue?vue&type=template&id=2818bb83&scoped=true&"
import script from "./network.vue?vue&type=script&lang=js&"
export * from "./network.vue?vue&type=script&lang=js&"
import style0 from "./network.vue?vue&type=style&index=0&id=2818bb83&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2818bb83",
  null
  
)

export default component.exports